export default __webpack_public_path__ + "static/media/platinum-category-icon.dc54989e.svg";